export enum V2ParameterValueType
{
    // Строковый.
    String = 0,
    // Целочисленный.
    Int = 1,
    // Дробный.
    Double = 2,
    // Булево.
    Bool = 3,
    // Набор параметров.
    ValueSet = 4,
    // Запись из нескольких полей. Поле записи так же может быть записью.
    Record = 5,
    // Дата.
    Date = 6,
    // Формула (только для типа поля записи).
    Formula = 7,
}

export enum PreCheckResult
{
    ActionAllowedCompletely = 0,
    ActionAllowedPartially = 1,
    ActionForbidden = 2
}

// Тип множества. Возможность добавления в множество новых значений вне настроек.
export enum V2ParameterValueSetExtensionType
{
    // Закрытое множество. Пользователь не может добавить новое значение.
    Closed = 0,
    // Открытое множество. Для добавления нового значения требуется подтверждение пользователя.
    ExtendableOnApply = 1,
    //  Открытое множество. Для добавления нового значения не требуется подтверждение пользователя.
    Extendable = 2
}

export enum SelectionParametersFilterSendDescriptor
{
    Record = 0,
    String = 1,
    StringSet = 2,
    Bool = 3,
    DateStamps = 4,
    Number = 5
}

export enum SelectionFilterSendConnector
{
    Immutable = 0,
    Or = 1,
    And = 2
}

export enum SelectionParameterFilteringOption
{
    // Нельзя выбирать опцию фильтрации.
    Immutable = 0,
    // Не фильтровать.
    None = 1,
    // Фильтровать только данный параметр - список.
    OnlyThisList = 2,
    // Фильтровать список и связанные поля.
    ThisListAndRelated = 3
}

export enum BooleanFilterFlags
{
    Nothing = 0,
    Null = 1,
    False = 2,
    True = 4,
}

export enum V2ParameterValueSet_ValueType
{
    // Строка
    String = 0,
    // Целочисленный
    Int = 1, 
    // Дробный
    Decimal = 2,
    // Дата
    Date = 3
}

// Тип сущности, к которой прикрепляется вхождение параметра.
export enum V2ParameterAttachmentType
{
    Client = 0,
    Project = 1
}
